import english from './en.js';
import spanish from './es.js';
import portugueseBr from './pt-BR.js';

const dictionaryMapper = {
  English: english,
  Spanish: spanish,
  'Portuguese (BR)': portugueseBr
};

export function getTranslation(key, language) {
  if (!key || !language) {
    console.log(`Invalid translation params key ${key} and language ${language}`);
    return '';
  }
  const dictionary = dictionaryMapper[language];

  if (!dictionary) {
    console.log(`No dictionary found for language ${language}. `);
    return '';
  }

  const translation = dictionary[key];

  if (!translation) {
    console.log(`No translation found for key ${key} in language ${language}`);
    return '';
  }
  return translation;
}

export function getAllLanguages() {
  return Object.keys(dictionaryMapper);
}



// WEBPACK FOOTER //
// ./src/translations/dictionary.js